import {Environment} from './environment';

export const cmsUrlByEnvironment: Record<Environment, string> = {
  production: 'https://aboutyou.content.aboutyou.cloud',
  preview: '', // does not exist
  staging: 'https://aboutyou.content.staging.aboutyou.cloud',
  development: 'http://aboutyou.localhost:3000',
};
